import React, { useEffect, useState } from "react";
import "./TechHeroSection.css";



const images = [
  "/images/techHero1.jpg",
  "/images/techHero2.png",
  "/images/techHero3.jpg",
  "/images/techHero4.png",
];

const TechHeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 2000); 
    return () => clearInterval(interval); 
  }, [currentIndex]);

  
  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

 
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="slider-container">
      
      <div className="text-section">
        <h1>Our Technology </h1>
        <p>DataDisca utilises the complete data science technology spectrum.</p>
      </div>

      <div className="slider">
        
        <img src={images[currentIndex]} alt="slide" className="slide-image" />

        
        <button className="prev-button" onClick={prevSlide}>
          &#10094;
        </button>
        <button className="next-button" onClick={nextSlide}>
          &#10095;
        </button>

       
        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechHeroSection;
